/**
 * Created by Tomasz Gabrysiak @ Infermedica on 03/02/2017.
 */

const template = `
  <div class="card">
      <div class="card-header">
          <i class="fa fa-user-md"></i> উপসর্গ যাচাইকারী <span class="d-none d-sm-block float-right text-muted">powered by <a href="http://infermedica.com/">Infermedica</a></span>
      </div>
      <div id="step-container" class="card-block">
        <!-- dynamic content goes here -->
      </div>
      <div class="card-footer">
          <button id="next-step" class="btn btn-primary float-right">পরবর্তী <i class="fa fa-chevron-right"></i></button>
      </div>
  </div>
`;

export default template;



// WEBPACK FOOTER //
// ./src/templates/base.js